import { mediaData } from "@/mocks/homeData";

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2 font-heading">🎬 吃瓜视频精选</h2>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10">热门51吃瓜事件视频解读，深度剖析娱乐圈内幕</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all hover:border-primary-200/50 ${
                i === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? "aspect-[16/7]" : "aspect-[4/3]"}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center border-2 border-white/40 group-hover:bg-white/30 transition-all group-hover:scale-110">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded-md whitespace-nowrap font-mono">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className={`font-semibold text-foreground-950 leading-snug mb-2 line-clamp-2 font-heading ${
                  i === 0 ? "text-sm md:text-base" : "text-xs md:text-sm"
                }`}>
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i> {item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}